import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import BlogDashboardLoader from '../features/blogs/BlogDashboardLoader';

// Lazy load other components
const ArticleSummary = lazy(() => import('../features/blogs/ArticleSummary'));
const ArticleContext = lazy(() => import('../features/blogs/ArticleContext'));
const LoginPage = lazy(() => import("../features/authentication/LoginPage"));
const WelcomeLayout = lazy(() => import("../components/layouts/WelcomeLayout"));

// Loading component for all lazy-loaded routes
const LoadingComponent = () => (
  <div className="w-full h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-16 w-16 border-4 border-primary border-t-transparent"></div>
  </div>
);

const AppRoutes = [
    {
        path: "*",
        element: <Suspense fallback={<LoadingComponent />}><LoginPage/></Suspense>,
        isAuthenticated: false
    },
    {
        path: "/",
        element: <Navigate to="/crm/dashboard" replace />,
        isAuthenticated: true
    },
    // Blog Routes
    {
        path: "/blog/blog-dashboard",
        element: <BlogDashboardLoader />,  // Using our custom loader instead of Suspense
        isAuthenticated: true
    },
    {
        path: "/blog/article-summary",
        element: <Suspense fallback={<LoadingComponent />}><ArticleSummary/></Suspense>,
        isAuthenticated: true
    },
    {
        path: "/blog/article-content",
        element: <Suspense fallback={<LoadingComponent />}><ArticleContext/></Suspense>,
        isAuthenticated: true
    },
    {
        path: "/blog/article-tags",
        element: <Suspense fallback={<LoadingComponent />}><WelcomeLayout/></Suspense>,
        isAuthenticated: true,
    },
]

export default AppRoutes;

